(function($) {

	'use strict';

	var init = function() {
        
        manageFormations();

    };
    
    var manageFormations = function() {

        $('#formations__filter__submit').click(function(e) {

            e.preventDefault();

            filterFormations();
            
        });

        $('#formations__filter__reset').click(function(e) {

            setTimeout(function() {
                filterFormations();
            }, 25);

        });

        var filterFormations = function() {

            var level = $('input[name="level"]:checked', '#formations__filter').val();

            var campus = $('select#campus', '#formations__filter').val();

            var rythm = $('select#rythm', '#formations__filter').val();

            var type = $('#formations__filter').data('type');

            var id = $('#formations__filter').data('id');

            var top = $('.formations-all').offset().top - $('.formations__container').offset().top;

            jQuery.post(
                MyAjax.ajaxurl,
                {
                    'action': 'formations_filter',
                    'level': level,
                    'campus': campus,
                    'rythm': rythm,
                    'type': type,
                    'id': id,
                    'hidden': true
                },
                function(response){

                    if(response != 'false'){

                        $('.formations__container').css('height', $('.formations__container').height());

                        $('.formations-all').css('top', top + 'px').addClass('fade-out').fadeOut(800, function() {
                            $('.formations-all.fade-out').remove();
                        });

                        $('.formations__container').append(response);
                        
                        setTimeout(function() {
                            if($('.formations-all.hidden')) {
                                $('.formations__container').css('height', $('.formations-all.hidden').height() + top + 'px');
                                $('.formations-all.hidden').removeClass('hidden');
                            } else {
                                $('.formations__container').css('height', 'auto');
                            }
                        }, 100);
                        
                    }
                }
            );

        };
        
    }

	$(document).ready(function() {
		init();
	});

})(jQuery);